import { useAtom } from 'jotai';
import { loginState } from '../state';

export function useLoginState() {
    return useAtom(loginState);
}